<template>
    <div>
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>
        <div v-if="albumMain">
             <app-header :info="albumMain.album" :title="title" :imagePath="albumMain.album.imagePath" isType="album" :shortDesc="albumMain.album.short_description"></app-header>

            <div class="custom-description" v-if="albumMain.album.description" v-html="albumMain.album.description"></div>
            <div class="custom-description" v-if="albumMain.album.extra_description" v-html="albumMain.album.extra_description"></div>
            <div class="custom-description">
                <!-- hardcoded only for tesi and ola -->
                <silentbox-single v-if="albumMain.album.id === 1 || albumMain.album.id === 2" :src="pedigreePath(albumMain.album.id, albumMain.album.slug + '-pedigree-sl.jpg', true)" :autoplay="true" :description="capitalize(albumMain.album.name) + ' Pedigree'"><img :src="pedigreePath(albumMain.album.id, albumMain.album.slug + '-pedigree-sl.jpg', false)" /></silentbox-single>
            </div>


            <div v-if="albumMain.photos" class="bg-light ptb-80">
                <app-sb :photos="albumMain.photos" :albumId="id"></app-sb>
            </div>
        </div>
    </div>
</template>

<script>
import { ApiHome, baseUrl } from '../../.env';
import StringsMixin from '../../mixins/StringsMixin';
import { mapGetters, mapActions } from 'vuex';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';

export default {
    mixins: [StringsMixin],
    // set props to T, pass the id instead of using this.$route.params.id
    props: ['id'],
    data() {
        // console.log('ALBUM id: ', document.title, this.id);
        return {
            endpoint: ApiHome+ 'album/' + this.id,
            photoSize: '1280',
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-sb': Silentbox,
        'app-back': BackButton,
    },

    computed: {
        ...mapGetters([
            'albumMain',
            'loading',
            'error',
            'title'
        ]),

        imagePath() {
            return AlbumsPhotoUrl + this.photoSize + '/';
        },
    },

    methods: {
        pedigreePath(id, image, src) {
            if(src !== undefined && !src) {
                return baseUrl + '/uploads/'+ id + '/pedigree/960/' + image;
            }
            return baseUrl + '/uploads/'+ id + '/pedigree/1280/' + image;
        },
        fetchAlbum() {
            // console.log('fetch album from album.vue');
            this.$store.dispatch('fetchAlbum', this.endpoint);
        },
    },

    created() {
        // console.log('ALBUM - Component created.')
        this.fetchAlbum();
    }
}
</script>

<style lang="scss">
    .custom-description {
        margin: 1rem 5rem !important;
        img {
            display: block;
            margin: 0 auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/albums/Album.vue